import { PartnerConfig } from "../tenant.types";
import { Texts } from "./texts.types";

const DEFAULT_TEXTS: Texts = {
  home: {
    title: "A economia começa agora!",
    description: "IVI é uma escolha limpa, inteligente e econômica para sua empresa.",
  },
  selectYourDistributor: {
    title: "Não encontrei minha distribuidora",
    description: "Basta selecionar a sua distribuidora e manteremos você informado sobre a IVI na sua região!",
  },
  contact: {
    title: "Dados de Contato",
    description: "Preencha os seus dados cadastrais para criar sua conta na IVI Energia.",
  },
  validation: {
    title: "",
    description: "",
  },
  holder: {
    title: "Dados do Titular",
    description: "Preencha os dados do titular da conta de luz.",
  },
  holderPF: {
    title: "Dados do Titular",
    description: "Preencha os dados do titular da conta de luz.",
  },
  holderPJ: {
    title: "Dados do Representante Legal",
    description: "Preencha os dados do representante legal.",
  },
  installation: {
    title: "Adicionar imóvel",
    description:
      "Envie o PDF da sua conta de energia mais recente para analisarmos seu perfil de consumo e não se esqueça de adicionar a senha do PDF, caso necessário.",
  },
  confirmYourData: {
    title: "Confirme seus dados",
    description: "Verifique os seus dados cadastrais e os dados da conta de energia antes de prosseguir para assinatura do contrato.",
  },
  contractOfAdhesion: {
    title: "Termo de adesão",
    description: "Leia o termo de adesão com atenção, faça o upload do seu documento e efetue a assinatura para começar a economizar.",
  },
  pdfErrorValidation: {
    title: "Solicitação de validação enviada!",
    description:
      "Sua fatura será analisada e, em breve, enviaremos um e-mail com o retorno e um link, para que você possa dar continuidade ao seu cadastro.",
  },
  weAreAlmostThere: {
    title: "Estamos quase lá!",
    description:
      "Infelizmente ainda não atendemos a sua região. Enviaremos notícias da IVI no seu estado para que, em breve, você possa utilizar uma energia renovável e mais barata!",
  },
  unapprovedAccount: {
    title: "Conta não atende os requisitos",
    description:
      "Avaliamos seu perfil de consumo e, infelizmente não será possível dar continuidade ao seu cadastro. Manteremos o seu cadastro em nossa base para futuras oportunidades.",
  },
  choosePlan: {
    title: "",
    description: "",
  },

};

// Texto padrão para parceiros que não possuem textos customizados no fluxo de vendedor
const DEFAULT_SELLER_TEXTS: Texts = {
  ...DEFAULT_TEXTS,
  choosePlan: {
    title: "Escolha o plano",
    description: "Escolha o plano que melhor se adapta ao perfil de consumo do seu cliente.",
  },
  contact: {
    title: "Dados do Contato",
    description: "Preencha os dados de contato do <strong>cliente</strong> para criar uma conta na IVI Energia.",
  },
};

const BENUP_TEXTS: Texts = {
  ...DEFAULT_TEXTS,
  home: {
    title: "A economia começa agora!",
    description: "A IVI é uma escolha limpa, inteligente e econômica para sua casa ou empresa.",
  },
};

const BENUP_SELLER_TEXTS: Texts = {
  ...DEFAULT_SELLER_TEXTS,
  home: BENUP_TEXTS.home,
};

const texts: Record<PartnerConfig, Texts> = {
  DEFAULT: DEFAULT_TEXTS,
  BENUP: BENUP_TEXTS,
};

const sellerTexts: Record<`${PartnerConfig}_SELLER`, Texts> = {
  DEFAULT_SELLER: DEFAULT_SELLER_TEXTS,
  BENUP_SELLER: BENUP_SELLER_TEXTS,
};

export { texts, sellerTexts };
